import { DashboardCardState } from '../models/dashboard/dashboard-card-state';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

export abstract class AbstractDashboardStore {
  private cardStateSubject = new BehaviorSubject<DashboardCardState>(DashboardCardState.NOT_LOADED);

  abstract showCard(): Observable<boolean>;

  private beginLoad(): void {
    if (this.cardStateSubject.getValue() !== DashboardCardState.NOT_LOADED) {
      this.cardStateSubject.next(DashboardCardState.STALE);
    }
  }

  private endLoad(): void {
    this.cardStateSubject.next(DashboardCardState.LOADED);
  }

  get cardState(): Observable<DashboardCardState> {
    return this.cardStateSubject.asObservable();
  }

  isStale(): Observable<boolean> {
    return this.cardState.map((state: DashboardCardState) => {
      return Boolean(state === DashboardCardState.STALE);
    });
  }

  isLoading(): Observable<boolean> {
    return this.cardState.map((state: DashboardCardState) => {
      return Boolean(state === DashboardCardState.NOT_LOADED);
    });
  }

  cardStateCssClass(): Observable<string> {
    return Observable.combineLatest(
      this.isStale(),
      this.isLoading()
    ).map((values: boolean[]) => {
      const [stale, loading] = values;

      let newClasses = '';
      if (stale) {
        newClasses += ' stale';
      }
      if (loading) {
        newClasses += ' loading';
      }
      return newClasses;
    });
  }

  abstract loadTotalsWithCardStateHandled(): Observable<any>;

  loadTotals(): Observable<any> {
    this.beginLoad();
    return this.loadTotalsWithCardStateHandled()
      .map(totals => {
        this.endLoad();
        return totals;
      });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/service/abstract-dashboard.store.ts